import type { Theme } from '@epilot/journey-elements'
import { useTheme } from '@epilot/journey-elements'
import type { UiSchema } from '@epilot/journey-logic-commons'
import type { JsonSchema7 } from '@jsonforms/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'

export function IsMobile() {
  const theme = useTheme<Theme>()

  return useMediaQuery(theme.breakpoints.down('xs'), {
    noSsr: true
  })
}

export function IsMobileOrTablet() {
  const theme = useTheme<Theme>()

  return useMediaQuery(theme.breakpoints.down('sm'), {
    noSsr: true
  })
}

export const getBase64 = (file: File) =>
  new Promise((resolve) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (error) => {
      console.error('Error: ', error)
    }
  })

export const isObject = (arg: unknown): arg is Record<string, unknown> => {
  return (
    typeof arg === 'object' &&
    !Array.isArray(arg) &&
    arg !== null &&
    !!Object.keys(arg)
  )
}

/**
 * Gets availabile string values by first attempting to check for schema.enum property,
 * and then falls back to find those values in the uischema options
 */
export const getEnumOptions = (
  schema: JsonSchema7,
  uischema: UiSchema
): string[] => {
  if (Array.isArray(uischema?.options?.options)) {
    const options = uischema?.options?.options.map((option) =>
      option === undefined || option === null ? '' : option
    )

    if (options && options.every((option) => typeof option === 'string')) {
      return options
    }
  }

  if (schema?.enum) {
    return schema.enum
  }

  return []
}
